export default __webpack_public_path__ + "static/mainImage-a70ec88e689084cd8d31d6ca8e8a0e24.jpeg";